"use strict";

exports.__esModule = true;
var _createPopper = require("./createPopper.js");
exports.createPopper = _createPopper.createPopper;
exports.popperGenerator = _createPopper.popperGenerator;
exports.detectOverflow = _createPopper.detectOverflow;